export const baseCellClassname = 'px-3 border-e border-base-70 last:border-none';
export const baseRowClassname = 'bg-white hover:bg-base-80 transition-background';
export const stickyShadowStyles =
  'after:absolute after:right-[-10px] after:top-0 after:w-2.5 after:h-full after:bg-linear-to-r after:from-base-10/15 after:to-transparent';
export const selectedColumnHeaderClassname =
  'relative bg-base-20 text-base-90 rounded-t-lg before:size-full before:absolute before:top-0 before:left-0 before:bg-base-70 before:z-[-1]';
export const errorColumnHeaderClassname =
  'relative bg-danger-70 text-base-20 rounded-t-lg before:size-full before:absolute before:top-0 before:left-0 before:bg-base-70 before:z-[-1]';
export const shiftButtonHoverClassname =
  'before:size-full before:absolute before:top-0 before:left-0 before:bg-black before:opacity-0 hover:before:z-2 hover:before:opacity-20 before:transition-opacity before:duration-150';
